import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { I18NService } from 'src/core/services/i18n/i18n.service';
import { StartupService } from 'src/core/services/startup/startup.service';
import { environment } from '@env/environment';
import { protectPassword } from '@constants';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
    readonly env = environment;
    isMatched = !environment.needProtect;
    password = '';

    constructor(
        @Inject(DOCUMENT) private dom,
        private activatedRoute: ActivatedRoute,
        private i18n: I18NService,
        private startupService: StartupService,
    ) {}

    async ngOnInit(): Promise<void> {
        if (this.activatedRoute.snapshot.routeConfig.path === 'coffee') {
            this.i18n.use('en');
            await this.startupService.load();
        } else if (this.activatedRoute.snapshot.routeConfig.path === 'kaffe') {
            this.i18n.use('sv');
            await this.startupService.load();
        }
    }

    onCheckPassword() {
        this.isMatched = this.password === protectPassword || !environment.needProtect;
    }
}
